import * as Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import 'highcharts/highcharts-more'
import { useEffect, useState, useMemo } from 'react'
import { isDarkTheme } from '../../utils.js'
import { useTranslation } from 'react-i18next'
import { useAppContext } from '../../contexts/AppContext.jsx'
import { ON_ACTION_CARD_SAVE_EVENT } from '../../constants/index.js'
import { getHighchartOptions } from '../../services/scoringDimensionsService.js'
import { TriangleAlert } from 'lucide-react'

const SpiderChart = () => {
  const { t } = useTranslation()
  const { actionCard, accentColor } = useAppContext()
  const [justUpdatedActionCard, setJustUpdatedActionCard] = useState(actionCard)
  const isDark = isDarkTheme()

  useEffect(() => {
    const onSaveData = e => {
      setJustUpdatedActionCard(e.detail)
    }

    addEventListener(ON_ACTION_CARD_SAVE_EVENT, onSaveData)
    return () => {
      removeEventListener(ON_ACTION_CARD_SAVE_EVENT, onSaveData)
    }
  }, [])

  const options = useMemo(() => {
    if (!justUpdatedActionCard) return

    return getHighchartOptions(justUpdatedActionCard, isDark)
  }, [justUpdatedActionCard])

  return options ? (
    <HighchartsReact highcharts={Highcharts} options={options} />
  ) : (
    <div className="flex items-center justify-center">
      <div
        className="text-sm w-[300px] p-1 rounded bg-zinc-50 flex flex-col items-center text-center dark:bg-zinc-900 text-zinc-500 shadow-md py-4"
        style={{ borderColor: accentColor }}
      >
        <TriangleAlert className="fill-yellow-400 shrink-0 text-black size-10 mb-2" />
        <div className="px-4">
          {t('chart.noDimensionsWarning', "This Action Cards doesn't support scoring dimensions to display a chart")}
        </div>
      </div>
    </div>
  )
}

export default SpiderChart
